import { OtelTelemetryProcessor } from './otelTelemetryProcessor';
/**
 * Gets the relevant telemetry processor
 *
 * @returns Instance of the relevant processor
 */
export function getMfsTelemetryProcessor(bufferContainer) {
    return new OtelTelemetryProcessor(bufferContainer);
}
//# sourceMappingURL=telemetryProcessorFactory.js.map